module.exports = __webpack_public_path__ + "9941171b03d0746661c1ccff449728ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo512x512.png
// module id = 427
// module chunks = 0